import { apiClient } from "@/lib/apiClient";

/**
 * Provisions and products each carry a broad, shared category — the API calls
 * it a type. The list is read-only: it is the same taxonomy for every
 * organisation, so nobody creates one from the app.
 */
export type Category = {
  code: string;
  name: string;
};

export const PROVISION_TYPES_KEY = "provision-types";
export const PRODUCT_TYPES_KEY = "product-types";

/** The catch-all every row falls back to when nothing better fits. */
export const FALLBACK_CATEGORY_CODE = "0000";

const list = async (endpoint: string): Promise<Category[]> => {
  const categories = await apiClient.get<Category[]>(endpoint);
  return Array.isArray(categories) ? categories : [];
};

export const listProvisionTypes = (): Promise<Category[]> => list(PROVISION_TYPES_KEY);

export const listProductTypes = (): Promise<Category[]> => list(PRODUCT_TYPES_KEY);
